"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLatestValuesFrom = exports.probe = exports.filterEnumSubset = exports.asValueFrom = exports.filterByAll = exports.filterByLatest = exports.filterNotUndefined = exports.filterNotValue = exports.filterValue = exports.valueIsNot = exports.valueIs = exports.skipUnchangedImmutable = exports.get = exports.mapToConst = void 0;
var tslib_1 = require("tslib");
var operators_1 = require("rxjs/operators");
var utils_1 = require("../../../utils");
var functions_1 = require("../../functions");
var combine_latest_1 = require("../combine-latest");
var every_1 = require("./every");
var mapToConst = function (constant) {
    return (0, operators_1.mapTo)(constant);
};
exports.mapToConst = mapToConst;
exports.get = operators_1.pluck;
var skipUnchangedImmutable = function () {
    return (0, operators_1.distinctUntilChanged)(function (a, b) { return (0, utils_1.Iis)(a, b); });
};
exports.skipUnchangedImmutable = skipUnchangedImmutable;
var valueIs = function (value) { return (0, operators_1.map)(function (v) { return (0, utils_1.Iis)(v, value); }); };
exports.valueIs = valueIs;
var valueIsNot = function (value) { return (0, operators_1.map)(function (v) { return !(0, utils_1.Iis)(v, value); }); };
exports.valueIsNot = valueIsNot;
var filterValue = function (value) { return function (input$) {
    return input$.pipe((0, operators_1.filter)(function (v) { return (0, utils_1.Iis)(v, value); }), (0, operators_1.map)(function (e) { return e; }));
}; };
exports.filterValue = filterValue;
var filterNotValue = function (value) { return (0, operators_1.filter)(function (v) { return !(0, utils_1.Iis)(v, value); }); };
exports.filterNotValue = filterNotValue;
var filterNotUndefined = function () { return (0, operators_1.filter)(functions_1.isNotUndefined); };
exports.filterNotUndefined = filterNotUndefined;
var filterByLatest = function (condition$) { return function (input$) {
    return input$.pipe((0, operators_1.withLatestFrom)(condition$), (0, operators_1.filter)(function (_a) {
        var _b = tslib_1.__read(_a, 2), _value = _b[0], condition = _b[1];
        return condition;
    }), (0, operators_1.map)(function (_a) {
        var _b = tslib_1.__read(_a, 2), value = _b[0], _condition = _b[1];
        return value;
    }));
}; };
exports.filterByLatest = filterByLatest;
var filterByAll = function () {
    var conditions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        conditions[_i] = arguments[_i];
    }
    return function (input$) { return input$.pipe((0, exports.filterByLatest)(every_1.every.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(conditions), false)))); };
};
exports.filterByAll = filterByAll;
var asValueFrom = function (from) { return function (input$) {
    return input$.pipe((0, operators_1.withLatestFrom)(from), (0, operators_1.map)(function (_a) {
        var _b = tslib_1.__read(_a, 2), _ = _b[0], value = _b[1];
        return value;
    }));
}; };
exports.asValueFrom = asValueFrom;
var filterEnumSubset = function (enumSubset) { return function (input$) {
    return input$.pipe((0, operators_1.filter)(function (e) { return enumSubset.includes(e); }), (0, operators_1.map)(function (e) { return e; }));
}; };
exports.filterEnumSubset = filterEnumSubset;
var probe = function (callback) {
    if (callback === void 0) { callback = console.log; }
    return (0, operators_1.map)(function (v) {
        callback(v);
        return v;
    });
};
exports.probe = probe;
var withLatestValuesFrom = function () {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function (input$) {
        return input$.pipe((0, operators_1.withLatestFrom)(combine_latest_1.combineLatestTyped.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(observables), false))));
    };
};
exports.withLatestValuesFrom = withLatestValuesFrom;
